import axios, {AxiosResponse} from "axios";

const PATH_V3 = "/v3/orders";

export interface OrderOperatorUpdateRequestV3 {
  operatorNumber?: number;
  numberOfPositions?: number;
  qualityLevel?: string;
  valueOfGoods?: number;
}

export interface OrderOperatorCreateRequestV3 extends OrderOperatorUpdateRequestV3 {
  employeeId: string;
}

export interface OrderOperatorV3Dto {
  id: string;
  operatorNumber?: number;
  employee: {
    id: string;
    employeeNumber?: number;
    firstName: string;
    lastName: string;
  };
  numberOfPositions?: number;
  qualityLevel?: string;
  valueOfGoods?: number;
}

class OrderOperatorService {

  getOrderOperatorsV3 (orderUuid: string): Promise<AxiosResponse<{ operators: Array<OrderOperatorV3Dto> }>> {
    return axios.get(`${PATH_V3}/${orderUuid}/operators`);
  }

  createOrderOperatorV3 (orderUuid: string, data: OrderOperatorCreateRequestV3): Promise<AxiosResponse<OrderOperatorV3Dto>> {
    return axios.post(`${PATH_V3}/${orderUuid}/operators`, data, { headers: { "Content-Type": "application/json" } });
  }

  updateOrderOperatorV3 (orderUuid: string, operatorId: string, data: OrderOperatorUpdateRequestV3): Promise<AxiosResponse<OrderOperatorV3Dto>> {
    return axios.put(`${PATH_V3}/${orderUuid}/operators/${operatorId}`, data, { headers: { "Content-Type": "application/json" } });
  }
}

export default new OrderOperatorService();
